import EditIcon from '@mui/icons-material/Edit';
import { getChannelIcon } from '@helpers/channels';
import { DeleteIcon } from 'assets/images/icons';
import { Typography } from '@components/Typography';
import { CHANNEL, CHANNEL_MAP, STATUS } from '@constants/channels';
import { useTranslation, useHasAccessToAsset } from '@hooks';
import { StyledIconButton, Container, Footer, Controls } from './styles';

const ChannelItem = ({ channel, companies, brands, isSubmitting, onClickDelete, onClickEdit }) => {
    const { t } = useTranslation();
    const { hasAccessToChannel } = useHasAccessToAsset();

    const hasAccessToAsset = hasAccessToChannel(channel.brandId);

    const locationName = channel.locationId
        ? companies.find(c => c.companyId === channel.locationId)?.internalName
        : brands.find(b => b.id === channel.brandId)?.title;

    return (
        <Container>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="subtitle2">{channel.name}</Typography>
                {channel?.type === CHANNEL.WHATSAPP && channel?.status === STATUS.PENDING ? (
                    <Typography variant="caption" sx={{ color: '#FF8700' }}>
                        {t('SettingsChannels.pending')}
                    </Typography>
                ) : null}
                {channel?.status === STATUS.DISCONNECTED ? (
                    <Typography variant="caption" sx={{ color: '#B00020' }}>
                        {t('SettingsChannels.disconnected')}
                    </Typography>
                ) : null}
            </div>
            <Typography
                variant="caption"
                sx={{
                    color: locationName ? 'rgba(0, 0, 0, 0.6)' : '#fff',
                    margin: '4px 0 16px',
                    display: 'inline-block',
                }}
            >
                {locationName}
            </Typography>
            <div style={{ width: '100%', height: 1, backgroundColor: 'rgba(0, 0, 0, 0.12)' }} />
            <Footer>
                <div style={{ display: 'flex', alignItems: 'center', gap: 4, height: 32 }}>
                    <Typography variant="caption" color="textSecondary">
                        {t('common.type')}:
                    </Typography>
                    {getChannelIcon(channel.type)}
                    <Typography variant="caption" color="textSecondary">
                        {CHANNEL_MAP[channel?.type]}
                    </Typography>
                </div>
                {hasAccessToAsset ? (
                    <Controls>
                        <StyledIconButton
                            disabled={
                                isSubmitting ||
                                (channel.type === CHANNEL.EMAIL && channel.isDefault) ||
                                (channel.type === CHANNEL.SMS && channel.isDefault)
                            }
                            onClick={() => onClickEdit(channel)}
                        >
                            <EditIcon />
                        </StyledIconButton>
                        <StyledIconButton
                            disabled={
                                isSubmitting ||
                                (channel.type === CHANNEL.EMAIL && channel.isDefault) ||
                                (channel.type === CHANNEL.SMS && channel.isDefault)
                            }
                            onClick={() => onClickDelete(channel)}
                        >
                            <DeleteIcon />
                        </StyledIconButton>
                    </Controls>
                ) : null}
            </Footer>
        </Container>
    );
};

export default ChannelItem;
